import { Breadcrumb, Layout, Menu, Dropdown, Button, Drawer } from 'antd';
import { UserOutlined, ZhihuOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../context/UserContext";
import { useEffect, useState } from "react";
import ApiService from "../../../service/ApiService";
import { LocalStorageService } from "../../../service/LocalStorageService";

const { SubMenu } = Menu;

export default function ProfileDropdown({ isMobile, textColor }) {
    const { t } = useTranslation();
    const { signOut, setUser, user } = useUser();
    const [visible, setVisible] = useState(false)

    const onClick = (item) => {
        if (item.key === 'logout') {
            signOut()
        }
        else if (['en', 'tr'].includes(item.key)) {
            LocalStorageService.setLanguage(item.key)
            window.location.reload()
        }
    }

    const getUser = async () => {
        const response = await ApiService.User.Information();
        if (response.success) {
            setUser(response.data)
        }
    }

    useEffect(() => {
        ApiService.setLogout(signOut)
    }, [])

    useEffect(() => {
        getUser()
    }, [])

    const menu = (
        <Menu onClick={onClick}>
            <SubMenu icon={<ZhihuOutlined />} key={'languages'} title={t('Language')}>
                <Menu.Item key="en">
                    English
                </Menu.Item>
                <Menu.Item key="tr">
                    Türkçe
                </Menu.Item>
            </SubMenu>
            <Menu.Item key="logout" icon={<UserOutlined />}>
                {t('Logout')}
            </Menu.Item>
        </Menu>
    );

    if (isMobile) {
        return (
            <>
                <Button
                    type="text"
                    shape="circle"
                    onClick={() => setVisible(true)}
                    style={{ height: 40, width: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                    <UserOutlined style={{ color: textColor || '#595959', fontSize: '20px' }} />
                </Button>
                <Drawer
                    title={user?.name || t('Profile')}
                    placement="right"
                    closable={true}
                    onClose={() => setVisible(false)}
                    visible={visible}
                    bodyStyle={{ padding: 0 }}
                >
                    <Menu onClick={(item) => {
                        onClick(item);
                        setVisible(false);
                    }} mode="inline">
                        <SubMenu
                            icon={<ZhihuOutlined />}
                            key={'languages'}
                            title={t('Language')}
                            defaultOpenKeys={['languages']} // Mobilde açık gelsin
                        >
                            <Menu.Item key="en">English</Menu.Item>
                            <Menu.Item key="tr">Türkçe</Menu.Item>
                        </SubMenu>
                        <Menu.Item key="logout" icon={<UserOutlined />}>
                            {t('Logout')}
                        </Menu.Item>
                    </Menu>
                </Drawer>
            </>
        )
    }

    return (
        <Dropdown
            overlay={menu}
            placement="bottomRight"
            icon={<UserOutlined />}
            trigger={['click']}
        >
            <Button
                shape="round"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    borderColor: 'transparent',
                    background: 'rgba(0,0,0,0.02)',
                    color: textColor || 'inherit'
                }}
            >
                <UserOutlined style={{ color: textColor || 'inherit' }} />
                <span style={{ fontWeight: 500 }}>{user && `${user.name}`}</span>
            </Button>
        </Dropdown>
    )
}
